module.exports = __webpack_public_path__ + "img/guzhiReport_con.7c755917.png";